/* eslint-disable @typescript-eslint/no-explicit-any */
// import { createClient } from '@supabase/supabase-js';
import { AuthProvider } from 'react-admin';

import { supabaseAuthProvider } from 'ra-supabase';
import { supabase } from '../lib/supabaseClient';

// const isProdMod = process.env.NODE_ENV === 'development';

const isProdMod = true;

const siteUrl = process.env.REACT_APP_SITE_URL;
console.log('[Auth] REACT_APP_SITE_URL:', siteUrl);
console.log('[Auth] redirectTo:', siteUrl || '(not set, using Supabase default)');

export const authProvider: AuthProvider = {
  ...supabaseAuthProvider(supabase, {
    ...(siteUrl ? { redirectTo: siteUrl } : {}),
    getIdentity: async user => {
      return {
        id: user.id,
        fullName: user.user_metadata?.full_name || user.email,
        email: user.email,
      };
    },
  }),
};



// export const authProvider: AuthProvider | undefined = isProdMod
//   ? {
//       login: async (): Promise<any> => {
//         const { error } = await supabase.auth.signInWithOAuth(
//           {
//             // provider can be 'github', 'google', 'gitlab', and more
//             provider: 'google',
//           }
//         );
//         if (error) {

//           return Promise.reject(error);
//         }
        
//         return Promise.resolve();
//       },
//       logout: async (params: any): Promise<string | false | void> => {
//         const result = await supabase.auth.signOut();
//         if (result.error) {
//           return Promise.reject(result.error.message);
//         }
//         return Promise.resolve();
//       },
//       checkAuth: async (params: any): Promise<void> => {

//         const { data: { user } } = await supabase.auth.getUser()

//         if (!user) {
//           return Promise.reject({ message: false});
//         }

//       try{

//         if (!['director', 'coordinator', 'admin', 'staff'].includes(user.app_metadata.role.role)) {
//           console.log('OK');

//           return Promise.reject({ message: false});
//         }
//       }
//       catch{
//         console.log('uhoh');

//         const result = await supabase.auth.signOut();
//         return Promise.resolve();
//       }


//       const { data, error } = await supabase.auth.getSession()



//         if (data.session?.expires_at ?? 0 > Date.now()) {
//           return Promise.resolve();
//         }

//         return Promise.reject({ message: false});
//       },
//       checkError: (error: any): Promise<void> => {
//         const status = error.status;
//         if (status === 401 || status === 403) {
//           return Promise.reject();
//         }
//         // other error code (404, 500, etc): no need to log out
//         return Promise.resolve();
//       },

//       getPermissions: (params: any): Promise<any> => {
//         return Promise.resolve();
//       },
//       // getIdentity: async () => {
//       //   const { data: { user } } = await supabase.auth.getUser()
//       //   if (!user) {
//       //     return Promise.reject();
//       //   }
//       //   return Promise.resolve({
//       //     id: user.id,
//       //     name: user.user_metadata.name,
//       //     email: user.email,
//       //     avatar: user.user_metadata.picture,
//       //   });
//       // },
      
//     }
//   : undefined;

  export const getToken = async () => {
    const { data, error } = await supabase.auth.getSession();
    return data.session?.access_token ?? process.env.REACT_APP_PUBLIC_TOKEN;
  };

  export const getRefreshToken = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
  
    return session?.refresh_token ?? '';
  };